var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMypaymark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 110.99 26.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3823"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.97 19.96V6.4h3.38l2.42 10.05 2.36-10h3.3v13.51h-2.04V8.68l-2.76 11.28h-1.86L32.02 8.68v11.28z",
    id: "path3827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.24 9.74h2.2l1.77 7.68 1.63-7.68h2.15l-2.81 10.6a5.11 5.11 0 01-1.27 2.62 3.71 3.71 0 01-2.3.5 5.73 5.73 0 01-.82-.08v-1.63a4.45 4.45 0 00.66.07c.76 0 1.23-.26 1.39-.79l.27-.84z",
    id: "path3829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.83 19.96V6.4h4.29a3.56 3.56 0 012.85 1.1 4.16 4.16 0 01.9 2.85 4 4 0 01-1 2.92 3.85 3.85 0 01-2.93 1.09h-1.9v5.6zm2.16-11.93v4.69h1.54c1.45 0 2.17-.78 2.17-2.33a2.07 2.07 0 00-2.32-2.36z",
    id: "path3831"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.43 11.99v5.86c0 .48.17.72.53.72a.62.62 0 00.34-.07v1.34a2.31 2.31 0 01-1 .25c-1.1 0-1.67-.45-1.72-1.36a2.72 2.72 0 01-2.55 1.5c-1.77 0-2.66-1-2.66-2.87a3.37 3.37 0 01.67-2.32 3.58 3.58 0 011.66-.91l1.59-.44a2.19 2.19 0 00.88-.4 1.17 1.17 0 00.32-.91c0-1-.47-1.52-1.41-1.52s-1.55.65-1.55 2h-1.94a3.44 3.44 0 01.78-2.49 3.81 3.81 0 012.81-.88 4.06 4.06 0 012.3.57 2.22 2.22 0 01.95 1.93zm-1.94 4.29v-1.71a4.19 4.19 0 01-1.12.56c-.67.23-1.06.37-1.16.42a1.63 1.63 0 00-.84 1.58 1.64 1.64 0 00.33 1.08 1.09 1.09 0 00.95.46c1.23.04 1.84-.77 1.84-2.39z",
    id: "path3833"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.21 9.74h2.2l1.77 7.68 1.63-7.68h2.15l-2.82 10.6a5 5 0 01-1.27 2.62 3.71 3.71 0 01-2.3.5 5.61 5.61 0 01-.81-.08v-1.63a4.32 4.32 0 00.66.07c.76 0 1.22-.26 1.39-.79l.26-.84z",
    id: "path3835"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.77 19.96V9.74h1.93v1.2h.07a2.64 2.64 0 012.45-1.47 2.27 2.27 0 012.38 1.56 2.87 2.87 0 012.58-1.56c1.66 0 2.49.91 2.49 2.72v7.77h-2v-7c0-1.23-.41-1.84-1.24-1.84a1.47 1.47 0 00-1.12.49 2.13 2.13 0 00-.54 1.52v6.86h-2v-7c0-1.23-.42-1.84-1.26-1.84a1.47 1.47 0 00-1.12.49 2.17 2.17 0 00-.62 1.49v6.86z",
    id: "path3837"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.95 11.99v5.86q0 .72.54.72a.64.64 0 00.34-.07v1.34a2.34 2.34 0 01-1 .25c-1.1 0-1.68-.45-1.73-1.36a2.7 2.7 0 01-2.54 1.5c-1.78 0-2.66-1-2.66-2.87a3.42 3.42 0 01.66-2.32 3.58 3.58 0 011.66-.91l1.6-.44a2.07 2.07 0 00.87-.4 1.14 1.14 0 00.33-.91c0-1-.47-1.52-1.41-1.52s-1.56.65-1.56 2h-1.94a3.44 3.44 0 01.78-2.49 3.83 3.83 0 012.81-.88 4 4 0 012.3.57 2.19 2.19 0 01.95 1.93zm-1.93 4.29v-1.71a4.29 4.29 0 01-1.13.53c-.67.23-1.05.37-1.15.42a1.63 1.63 0 00-.84 1.61 1.69 1.69 0 00.32 1.08 1.12 1.12 0 001 .46c1.18.04 1.8-.77 1.8-2.39z",
    id: "path3839"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.57 19.96V9.74h2v1.6a2.52 2.52 0 012.41-1.87 1.92 1.92 0 01.5.08v2.09a3.38 3.38 0 00-.86-.11c-1.37 0-2.05.77-2.05 2.31v6.12z",
    id: "path3841"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.08 19.96V6.4h2v7.61l3.12-4.27h2.39l-3.08 3.95 3.48 6.29h-2.22l-2.51-4.65-1.16 1.4v3.25z",
    id: "path3843"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.02 15.49a.59.59 0 00-.59-.59.58.58 0 00-.58.58.57.57 0 00.39.56l-.29 1.49a.35.35 0 00.16.35.67.67 0 00.67 0 .41.41 0 00.17-.35l-.29-1.51a.57.57 0 00.36-.53z",
    id: "path3845"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.4 7.73a1.31 1.31 0 00-.95.4 1.34 1.34 0 00-.39.95v2.65a.4.4 0 01-.38.4c.24.1.47 0 .57-.37l.33-1.75h2.19v-.94a1.32 1.32 0 00-.4-.95 1.34 1.34 0 00-.97-.39z",
    id: "path3847"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.43 0a13.43 13.43 0 1013.43 13.43A13.43 13.43 0 0013.43 0zm0 25.49a12.08 12.08 0 1112.08-12.08 12.08 12.08 0 01-12.08 12.08z",
    id: "path3849"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.43 2.59a11 11 0 1011 11 11 11 0 00-11-11zm0 20.52a9.67 9.67 0 119.66-9.66 9.67 9.67 0 01-9.66 9.68z",
    id: "path3851"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.43 5a8.49 8.49 0 108.49 8.48A8.49 8.49 0 0013.43 5zm4.15 13.13a.85.85 0 01-.88 1h-6.54a.94.94 0 01-.88-1v-8.1h2v-.9a2.17 2.17 0 014.33 0v2.65a.41.41 0 01-.39.41c.25.1.48 0 .58-.37l.34-1.75h1.48zm1-8h-.19v.69h-.12v-.69h-.2v-.11h.5zm.77.69h-.12v-.69l-.16.66h-.11l-.19-.66v.66h-.13v-.8h.2l.14.59.13-.59h.2z",
    id: "path3853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypaymark);
export default __webpack_public_path__ + "static/media/mypaymark.b188e96ba50cca8aa43b3b480a8fd0d6.svg";
export { ForwardRef as ReactComponent };